import type { MsgDeskLoadingProps } from '@/deskUiSkeletons/Shared/SharedSurfaceContext'

export function MsgDeskLoading({ contract, label = 'Loading cards', className = '' }: MsgDeskLoadingProps) {
  return (
    <div
      data-md-contract={contract}
      className={`flex min-h-screen w-full items-center justify-center bg-slate-50 text-xs font-semibold uppercase tracking-[0.2em] text-violet-600 ${className}`}
      role="status"
      aria-live="polite"
    >
      {label}
    </div>
  )
}
